import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { IDateRange } from "libraries/service/resources/model/search/IDateRange";
import * as moment from "moment";
import { ITextCode } from "libraries/service/resources/model/search/ITextCode";
import { FieldValue, IPatchTypeConfig, SearchUtils } from "./SearchUtils";
import { AfidiumServiceFieldsetService } from "../components/afidium-service-field/afidium-service-fieldset.service";

export interface IAfidiumServicePatchedValue {
    serviceCodes: string[];
    operationStatuses?: string[];
    whenExecutedOperation?: IDateRange;
    eligibilityStatuses?: string[];
}

@Injectable()
export class SearchUtilsService {

    constructor(
        private afidiumServiceFieldSetService: AfidiumServiceFieldsetService,
    ) {
    }

    public patchAllValues<TSearchParameters>(form: FormGroup, searchParameters: TSearchParameters, config: IPatchTypeConfig): void {
        const fields: { [key: string]: AbstractControl } = form.controls;
        Object.keys(fields).forEach((fieldName: string) => {
            const fieldValue: FieldValue = searchParameters[fieldName];
            if (fieldValue) {
                if (config.date && config.date.includes(fieldName)) {
                    const fieldValueDate: IDateRange = fieldValue as IDateRange;

                    fields[fieldName].patchValue({
                        missing: fieldValueDate && fieldValueDate.missing,
                        min: fieldValueDate && fieldValueDate.min
                            ? moment(fieldValueDate.min).toDate()
                            : null,
                        max: fieldValueDate && fieldValueDate.max
                            ? moment(fieldValueDate.max).toDate()
                            : null,
                    });
                } else if (config.codeText && config.codeText.includes(fieldName)) {
                    const fieldValueCodeText: ITextCode = fieldValue as ITextCode;

                    if (fieldValueCodeText) {
                        fields[fieldName].patchValue({
                            text: SearchUtils.getArrayValue(fieldValueCodeText.text),
                            code: SearchUtils.getArrayValue(fieldValueCodeText.code),
                        });
                    } else {
                        fields[fieldName].patchValue({
                            text: [],
                            code: [],
                        });
                    }
                } else if (config.array && config.array.includes(fieldName)) {
                    const fieldValueArray: string[] = fieldValue as string[];

                    if (fieldValueArray) {
                        fields[fieldName].patchValue(SearchUtils.getArrayValue(fieldValueArray));
                    } else {
                        fields[fieldName].patchValue([]);
                    }
                } else if (config.formArray && config.formArray.includes(fieldName)) {
                    const formArrayField: FormArray = fields[fieldName] as FormArray;
                    const patchedValue: IAfidiumServicePatchedValue[] = [];
                    let maxIndex: number = 0;
                    Object.keys(fieldValue).forEach((value: string, formArrayIndexNumber: number) => {
                        if (formArrayIndexNumber > maxIndex) {
                            maxIndex = formArrayIndexNumber;
                        }
                        let getAfidiumPatchedValue: IAfidiumServicePatchedValue;
                        getAfidiumPatchedValue = this.afidiumServiceFieldSetService.patchAfidiumServiceValue(fieldValue, config, formArrayIndexNumber);
                        patchedValue.push(getAfidiumPatchedValue);
                    });

                    for (let i: number = 0; i <= maxIndex; i++) {
                        this.afidiumServiceFieldSetService.addService(form);
                    }
                    formArrayField.patchValue(patchedValue);
                } else {
                    if (fieldValue) {
                        fields[fieldName].patchValue(fieldValue);
                    } else {
                        fields[fieldName].patchValue(null);
                    }
                }
            }
        });
    }
}
